import { Satellite, Car, Wifi, LayoutDashboard } from 'lucide-react';
import { useLanguage } from '@/context/LanguageContext';
import SectionHeading from '@/components/SectionHeading';
import { LogoMark } from '@/components/Logo';
import { Stagger, StaggerItem, Reveal } from '@/components/Reveal';

const ICONS = [Satellite, Car, Wifi, null, LayoutDashboard];

export default function HowItWorks() {
  const { t } = useLanguage();
  const steps = t('how.steps');
  return (
    <section className="mx-auto max-w-7xl px-5 py-24 lg:px-8" data-testid="how-section">
      <SectionHeading eyebrow="how.eyebrow" title="how.title" align="center" />
      <div className="relative mt-16">
        <svg className="pointer-events-none absolute inset-x-0 top-7 hidden h-8 w-full md:block" viewBox="0 0 1000 40" preserveAspectRatio="none" aria-hidden="true">
          <path d="M60 20 L940 20" stroke="#0EA5E9" strokeWidth="2" strokeDasharray="8 10" fill="none" opacity="0.45" style={{ animation: 'dash-move 1.6s linear infinite' }} />
        </svg>
        <Stagger className="grid grid-cols-2 gap-x-4 gap-y-10 md:grid-cols-5" gap={0.12}>
          {steps.map((s, i) => {
            const Icon = ICONS[i] || null;
            return (
              <StaggerItem key={s.t} className="relative text-center">
                <div className="relative mx-auto grid h-14 w-14 place-items-center rounded-2xl bg-gradient-to-br from-brand-blue to-brand-sky text-white shadow-[0_14px_30px_-10px_rgba(0,82,255,0.55)]" data-testid={`how-step-${i}`}>
                  {Icon ? <Icon className="h-6 w-6" /> : <LogoMark className="h-8 w-8" />}
                </div>
                <p className="mt-4 font-mono text-[10px] font-bold uppercase tracking-widest text-brand-dim" dir="ltr">0{i + 1}</p>
                <h3 className="mt-1 font-display text-base font-bold text-brand-ink">{s.t}</h3>
                <p className="mx-auto mt-1.5 max-w-[190px] text-xs leading-relaxed text-brand-steel">{s.d}</p>
              </StaggerItem>
            );
          })}
        </Stagger>
      </div>
      <Reveal delay={0.2} className="mt-10 text-center">
        <p className="font-mono text-[11px] uppercase tracking-widest text-brand-dim" dir="ltr">SATELLITE → VEHICLE → INTERNET → WIYAKGPS → DASHBOARD</p>
      </Reveal>
    </section>
  );
}
